import { call, put, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchReport,
    reportFetched,
    reportFetchFailed,
} from '../paidContractorInvoiceReport';

function* fetchReportEffect({ payload }) {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.paidContractorInvoicesReport,
            method: 'GET',
            queryParams: payload || {},
        });
        yield put(reportFetched(response));
    } catch (e) {
        yield put(reportFetchFailed(e.message));
    }
}

export const paidContractorInvoiceReportSagas = [
    takeLatest(fetchReport.type, fetchReportEffect),
];
